export default {
  baseInfo: {
    title: 'Base Info',
  },
  changelog: {
    title: 'Changelog',
    step1: {
      title: 'upload file',
      subtitle: 'subtitle',
    },
    step2: {
      title: 'modify contract amount',
      subtitle: 'subtitle',
    },
    step3: {
      title: 'create contract',
      desc: 'administrator',
    },
  },
};
